import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientImmunizationsSelector } from '../selectors'
import { IPatientImmunizationsState } from '../store/patientImmunizations.types'
import { PatientImmunizationsConstants } from '../store/patientImmunizations.constants'
import { setImmunizations } from '../store/patientImmunizations.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setImmunizationType() {
  const immunization: IPatientImmunizationsState = yield select(getPatientImmunizationsSelector)
  const { immunizations, immunizationType, key } = immunization
  const updatedImmunization = [...immunizations]
  const selectedImmunization = immunizations.find((immune) => immune.key === key)
  try {
    if (selectedImmunization) {
      selectedImmunization.immunizationType = immunizationType
      yield put(setImmunizations(updatedImmunization))
    }
  } catch (e) {
    yield put(throwPcrException(`setImmunizationType() error: ${e}`))
  }
}

export function* setImmunizationTypeSaga() {
  yield takeLatest([PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATION_TYPE], setImmunizationType)
}
